<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="md:col-6 col-12">
      <p-card>
        <div class="formgrid grid">
          <div class="field col-12">
            <label class="font-medium required-field">Название</label>
            <crm-template-subject-input
              [(subject)]="template.name"
              [isError]="$any(errors?.name)"
              class="w-full"></crm-template-subject-input>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field-checkbox mb-0 col-12">
            <p-checkbox
              [(ngModel)]="template.disabled"
              [binary]="true"
              inputId="disabled"></p-checkbox>
            <label [for]="'disabled'">Неактивный</label>
          </div>
        </div>
      </p-card>

      <p-card
        header="Детали"
        styleClass="mt-3">
        <div class="formgrid grid">
          <div class="field xl:col-6 col-12">
            <label class="font-medium">Эпик</label>
            <crm-master-milestone-single-select
              [masterMilestones]="masterMilestones"
              [(selectedMasterMilestone)]="template.masterMilestone"
              [isError]="$any(errors?.masterMilestone)"
              [customRequest]="true"
              appendTo="body"></crm-master-milestone-single-select>
            <small
              *ngIf="errors?.masterMilestone"
              class="p-error">
              {{ errors.masterMilestone | join }}
            </small>
          </div>

          <div class="field xl:col-6 col-12">
            <label class="font-medium">Родительский шаблон</label>
            <crm-single-select
              [options]="templates"
              [showClear]="true"
              [(selectedItem)]="template.parent"
              appendTo="body"></crm-single-select>
            <small
              *ngIf="errors?.parent"
              class="p-error">
              {{ errors.parent | join }}
            </small>
          </div>

          <div class="field xl:col-6 col-12">
            <label class="font-medium">Бюджетная статья</label>
            <crm-direction-single-select
              [directions]="directions"
              [(selectedDirection)]="template.direction"
              [groupsDisabled]="true"
              [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-direction-single-select>
            <small
              *ngIf="errors?.direction"
              class="p-error">
              {{ errors.direction | join }}
            </small>
          </div>

          <div class="field xl:col-6 col-12">
            <label class="font-medium">Бизнес единица</label>
            <crm-unit-single-select
              [(selectedUnit)]="template.unit"
              [isError]="$any(errors?.unit)"
              [showClear]="true"
              appendTo="body"></crm-unit-single-select>
            <small
              *ngIf="errors?.unit"
              class="p-error">
              {{ errors.unit | join }}
            </small>
          </div>

          <div class="field xl:col-6 col-12">
            <label class="font-medium">Действует до</label>
            <crm-datepicker
              [(value)]="template.activeUntil"
              (valueChange)="template.disabled = false"
              [inputStyleClass]="errors?.activeUntil ? 'ng-invalid ng-dirty' : ''"
              [minDate]="today"
              styleClass="w-full"></crm-datepicker>
            <small
              *ngIf="errors?.activeUntil"
              class="p-error">
              {{ errors.activeUntil | join }}
            </small>
          </div>

          <div class="field xl:col-6 col-12">
            <label class="font-medium">Приоритет</label>
            <crm-priority-single-select
              [(selectedPriority)]="template.priority"
              [styleClass]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.priority ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-priority-single-select>
            <small
              *ngIf="errors?.priority"
              class="p-error">
              {{ errors.priority | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium">Надзадача</label>
            <div class="flex align-items-center">
              <div class="flex-grow-1">
                <crm-auto-complete
                  [(value)]="template.parentProject"
                  [suggestions]="projects"
                  (completeMethod)="projectSearch($event.query)"
                  field="name"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                  [isError]="$any(errors?.parentProject)"
                  appendTo="body"></crm-auto-complete>
              </div>
              <div
                *ngIf="template.parentProject"
                class="flex-none">
                <p-button
                  icon="pi pi-times"
                  (click)="template.parentProject = null">
                </p-button>
              </div>
            </div>
            <small
              *ngIf="errors?.parentProject"
              class="p-error">
              {{ errors.parentProject | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium">Клиент</label>
            <crm-client-auto-complete
              [(selectedClient)]="template.client"
              [isError]="$any(errors?.client)"
              styleClass="w-full"
              class="w-full"
              inputStyleClass="w-full"
              [showClear]="true"
              [customSearch]="false"
              appendTo="body"></crm-client-auto-complete>
            <small
              *ngIf="errors?.client"
              class="p-error">
              {{ errors.client | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium">Филиал</label>
            <crm-filial-single-select
              [(selectedFilial)]="template.filial"
              [isError]="$any(errors?.filial)"
              [showClear]="true"
              appendTo="body"></crm-filial-single-select>
            <small
              *ngIf="errors?.filial"
              class="p-error">
              {{ errors.filial | join }}
            </small>
          </div>

          <div class="field col-12">
            <label class="font-medium">Суть</label>
            <crm-template-subject-editor
              [(value)]="template.description"
              height="250px">
            </crm-template-subject-editor>
            <small
              *ngIf="errors?.description"
              class="p-error">
              {{ errors.description | join }}
            </small>
          </div>

          <div class="field col-12">
            <h3 class="font-medium -mb-2">Планирование дедлайна</h3>
            <p-divider></p-divider>
            <crm-planning-deadline-form
              [planning]="template.deadline"
              [errors]="$any(errors?.deadline)"></crm-planning-deadline-form>
          </div>
        </div>
      </p-card>

      <div
        *ngIf="!template.parent"
        class="mt-3">
        <crm-planning-periodicity-card
          [planning]="template.planning"
          [errors]="$any(errors?.planning)"
          appendTo="body"></crm-planning-periodicity-card>
      </div>
    </div>

    <div class="md:col-6 col-12">
      <div
        *ngIf="(form$ | async)?.isShowDelete && periodicity !== TemplateEntityPeriodicityEnum.NONE"
        class="mb-3">
        <crm-created-projects-widget
          [projects]="createdProjects"
          [loading]="createdProjectsLoading"
          (directToProjectList)="directToProjectList()"></crm-created-projects-widget>
      </div>

      <p-card header="Участники">
        <div class="field">
          <label class="font-medium required-field">Ответственный</label>
          <crm-user-single-select
            [users]="users"
            [(selectedUser)]="template.responsible"
            (selectedUserChange)="updateMembers()"
            [isError]="$any(errors?.responsible)"
            [customSearch]="true"
            appendTo="body"></crm-user-single-select>
          <p
            *ngIf="errors?.responsible"
            class="p-error">
            {{ errors.responsible | join }}
          </p>
        </div>

        <h3 class="font-medium -mb-2">Аудиторы</h3>
        <p-divider></p-divider>
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [users]="users"
              [(selectedUsers)]="template.userAuditors"
              [isError]="$any(errors?.userAuditors)"
              [isFloatLabel]="false"
              [customRequest]="true"
              appendTo="body"></crm-user-multi-select>
            <p
              *ngIf="errors?.userAuditors"
              class="p-error">
              {{ errors.userAuditors | join }}
            </p>
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Группы</label>
            <crm-multi-select
              [(selectedItems)]="template.userGroupAuditors"
              [options]="userGroups"
              [class]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-multi-select>
            <p
              *ngIf="errors?.userGroupAuditors"
              class="p-error">
              {{ errors.userGroupAuditors | join }}
            </p>
          </div>
        </div>
      </p-card>

      <p-card
        header="Сделка"
        styleClass="my-3">
        <div class="field">
          <label class="font-medium">Сделка</label>
          <crm-deal-multi-select
            [(selectedDeals)]="template.deals"
            [isError]="$any(errors?.deals)"
            appendTo="body"></crm-deal-multi-select>
          <p
            *ngIf="errors?.deals"
            class="p-error">
            {{ errors.deals | join }}
          </p>
        </div>
      </p-card>

      <p class="text-xl font-medium ml-3">События</p>
      <p-divider></p-divider>

      <ng-container *ngFor="let checklist of template.checklists; let index = index">
        <p-card styleClass="mb-3 p-3 very-compact-card">
          <div class="p-fluid">
            <div class="field">
              <label class="font-medium required-field">Событие</label>
              <crm-template-subject-input
                [(subject)]="checklist.name"
                class="w-full"
                [isError]="$any(errors?.checklists?.[index]?.['name'])"></crm-template-subject-input>
              <small
                *ngIf="errors?.checklists?.[index]?.['name']"
                class="p-error">
                {{ errors.checklists[index]['name'] | join }}
              </small>
            </div>

            <div class="grid">
              <div class="col">
                <div class="field">
                  <label class="font-medium required-field">Тип</label>
                  <crm-single-select
                    [options]="checklistTypes"
                    [(selectedItem)]="checklist.type"
                    [filter]="false"
                    [styleClass]="errors?.checklists?.[index]?.['type'] ? 'ng-invalid ng-dirty' : ''"
                    [class]="errors?.checklists?.[index]?.['type'] ? 'ng-invalid ng-dirty' : ''"
                    appendTo="body"></crm-single-select>
                  <small
                    *ngIf="errors?.checklists?.[index]?.['type']"
                    class="p-error">
                    {{ errors.checklists[index]['type'] | join }}
                  </small>
                </div>
              </div>
              <div class="col">
                <div class="field">
                  <label class="font-medium">Эпик</label>
                  <crm-master-milestone-single-select
                    [masterMilestones]="masterMilestones"
                    [(selectedMasterMilestone)]="checklist.masterMilestone"
                    [isError]="$any(errors?.checklists?.[index]?.['masterMilestone'])"
                    [customRequest]="true"
                    appendTo="body"></crm-master-milestone-single-select>
                  <small
                    *ngIf="errors?.checklists?.[index]?.['masterMilestone']"
                    class="p-error">
                    {{ errors.checklists[index]['masterMilestone'] | join }}
                  </small>
                </div>
              </div>
            </div>

            <div class="field">
              <label class="font-medium required-field">Участники</label>
              <crm-user-multi-select
                [users]="participants"
                [(selectedUsers)]="checklist.responsible"
                [isError]="$any(errors?.checklists?.[index]?.['responsible'])"
                [isFloatLabel]="false"
                [customRequest]="true"
                appendTo="body"></crm-user-multi-select>
              <small
                *ngIf="errors?.checklists?.[index]?.['responsible']"
                class="p-error">
                {{ errors.checklists[index]['responsible'] | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Описание</label>
              <crm-template-subject-editor [(value)]="checklist.description"></crm-template-subject-editor>
              <small
                *ngIf="errors?.checklists?.[index]?.['description']"
                class="p-error">
                {{ errors.checklists[index]['description'] | join }}
              </small>
            </div>

            <div class="field">
              <h3 class="font-medium -mb-2">Планирование дедлайна</h3>
              <p-divider></p-divider>
              <crm-planning-deadline-form
                [planning]="checklist.deadline"
                [errors]="errors?.checklists?.[index]?.['deadline']"></crm-planning-deadline-form>
            </div>
          </div>

          <div class="flex justify-content-end">
            <button
              pButton
              type="button"
              icon="pi pi-trash"
              label="Удалить"
              class="p-button-danger p-button-text"
              (click)="deleteChecklist(checklist)"></button>
          </div>
        </p-card>
      </ng-container>

      <button
        pButton
        type="button"
        icon="pi pi-plus"
        label="Добавить событие"
        class="p-button-success p-button-text"
        (click)="addChecklist()"></button>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="md:col-6 col-12 flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveTemplate()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteTemplate()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
